import { apiGet, apiPost, apiPut } from '@/api/http';

import type { Specialization } from '@/types/reference';

const api_url = import.meta.env.VITE_API_URL;

export const getSpecializationList = () =>
  apiGet<Specialization[]>(`${api_url}specializations/`);

export const createSpecialization = (name: string) =>
  apiPost<Specialization>(`${api_url}specializations/`, { name });

export const setSpecializationList = (specializationIds: string[]) =>
  apiPut(`${api_url}recruiters/me/specializations/`, {
    specializations: specializationIds,
  });
